export default __webpack_public_path__ + "static/media/doubt-person.b09303f0.png";